import { FORM_FIELDS, FORM_FIELDS_NAMES, IWidgetLinkInputs } from './widget-configuration-form';
import { TFunction } from 'react-i18next';

interface IWidgetLinks {
	t: TFunction;
}

export const WIDGET_LINK_INPUTS = ({ t }: IWidgetLinks): IWidgetLinkInputs[] => [
	{
		key: FORM_FIELDS.SUCCESS_URL,
		fieldName: FORM_FIELDS.SUCCESS_URL,
		fieldLabel: t(FORM_FIELDS_NAMES.SUCCESS_URL),
		tooltipText: t('COLOR_MODULE.SUCCESS_TOOLTIP')
	},
	{
		key: FORM_FIELDS.REJECT_URL,
		fieldName: FORM_FIELDS.REJECT_URL,
		fieldLabel: t(FORM_FIELDS_NAMES.REJECT_URL),
		tooltipText: t('COLOR_MODULE.REJECT_TOOLTIP')
	},
	{
		key: FORM_FIELDS.CANCEL_URL,
		fieldName: FORM_FIELDS.CANCEL_URL,
		fieldLabel: t(FORM_FIELDS_NAMES.CANCEL_URL),
		tooltipText: t('COLOR_MODULE.CANCEL_TOOLTIP')
	}

];
